export default "__VITE_PUBLIC_ASSET__eb5607ce__"